import React from 'react';
import AdminInvoiceCreator from '../pages/AdminInvoiceCreator';

const FileTextIcon = ({ size = 20, className = "" }: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
);

const XIcon = ({ size = 20, className = "" }: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
);

interface InvoiceCreatorModalProps {
    isOpen: boolean;
    onClose: () => void;
    /** Offene Seminar-Anmeldungen (status: neu) — Badge im Header */
    pendingRegistrationsCount?: number;
}

const InvoiceCreatorModal: React.FC<InvoiceCreatorModalProps> = ({
    isOpen,
    onClose,
    pendingRegistrationsCount = 0,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100000] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 md:p-8 animate-fade-in">
            <div className="bg-[#08090b] border border-slate-800 rounded-3xl w-full max-w-[1600px] h-full max-h-[95vh] flex flex-col shadow-2xl relative overflow-hidden">
                <div className="flex items-center justify-between p-6 border-b border-slate-800 bg-[#0f1015]">
                    <h2 className="text-[#E6C299] font-black text-xl uppercase tracking-widest flex items-center gap-3">
                        <FileTextIcon size={24} /> Rechnungs-Creator
                        {pendingRegistrationsCount > 0 ? (
                            <span className="inline-flex items-center gap-2 rounded-full border border-orange-500/40 bg-orange-500/15 px-3 py-1 text-[10px] font-black uppercase tracking-widest text-orange-300 animate-pulse">
                                {pendingRegistrationsCount} neue Anmeldung{pendingRegistrationsCount === 1 ? '' : 'en'}
                            </span>
                        ) : null}
                    </h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-white bg-slate-800 hover:bg-slate-700 p-2 rounded-xl transition-colors border border-slate-700">
                        <XIcon size={20} />
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto p-4 md:p-8">
                    <div className="ui-freeze-active h-full">
                        <AdminInvoiceCreator />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceCreatorModal;
